import React from 'react';
import hwpl from "../assets/images/Footer/hwpl-white-logo.png";
import background from "../assets/images/Footer/bg-footer.jpg";
import './footer.css';
import { Link } from 'react-router-dom';

export default function Footer() {
    return (
        <div>
            <div className="footer-top">
                <div className="footer-top-line">
                    <div className="left-text1">
                        Looking for an IT Consultant ?
                    </div>
                    <div className="right-links2">
                        <Link to='/get-a-quote'> <button className="quote-btn1">GET A QUOTE →</button></Link>
                    </div>
                </div>
            </div>

            <footer
                className="main-footer"
                style={{ backgroundImage: `url(${background})` }}
            >
                <div className="auto-container">

                    {/* Widgets Section */}
                    <div className="widgets-section">
                        <div className="row clearfix">
                            {/* Big Column */}
                            <div className="big-column col-lg-6 col-md-12 col-sm-12">
                                <div className="row clearfix">
                                    {/* Footer Column */}
                                    <div className="footer-column col-lg-6 col-md-6 col-sm-12">
                                        <div className="footer-widget logo-widget">
                                            <div className="logo">
                                                <Link to='/'>
                                                    <img src={hwpl} alt="" />
                                                </Link>
                                            </div>
                                            <div className="text">
                                                Since 2005, Horizon Webinfo Pvt. Ltd. has completed more than 5,000 Web projects for nearly every type and size of organization, in nearly every industry, including small companies, start-ups.
                                            </div>

                                        </div>
                                    </div>
                                    {/* Footer Column */}
                                    <div className="footer-column quick-link-footer col-lg-6 col-md-6 col-sm-12">
                                        <div className="footer-widget newsletter-widget">
                                            <h4>Quick Links</h4>

                                            <ul className="quick-links">
                                                <li><i className="fas fa-chevron-right" aria-hidden="true"></i> <Link to='/'>Home</Link></li>
                                                <li><i className="fas fa-chevron-right" aria-hidden="true"></i> <Link to='/company/about'>Company</Link></li>
                                                <li><i className="fas fa-chevron-right" aria-hidden="true"></i> <Link to='/services'>Services</Link></li>
                                                <li><i className="fas fa-chevron-right" aria-hidden="true"></i> <Link to='/technology'>Technology</Link></li>
                                                <li><i className="fas fa-chevron-right" aria-hidden="true"></i> <Link to='/industries'>Industries</Link></li>
                                                <li><i className="fas fa-chevron-right" aria-hidden="true"></i> <Link to='/products'>Products</Link></li>
                                                <li><i className="fas fa-chevron-right" aria-hidden="true"></i> <Link to='/odoo'>Odoo</Link></li>
                                                <li><i className="fas fa-chevron-right" aria-hidden="true"></i> <Link to='/contact-us'>Contact Us</Link></li>
                                            </ul>
                                        </div>
                                    </div>

                                </div>
                            </div>
                            {/* Big Column */}
                            <div className="big-column col-lg-6 col-md-12 col-sm-12">
                                <div className="row clearfix">
                                    {/* Footer Column */}
                                    <div className="footer-column col-lg-6 col-md-6 col-sm-12">
                                        <div className="footer-widget contact-widget">
                                            <h4>Our Solution</h4>
                                            <ul className="quick-links">
                                                <li><i className="fas fa-chevron-right" aria-hidden="true"></i> <Link to='/services/website-development-in-ahmedabad'>Website Development</Link></li>
                                                <li><i className="fas fa-chevron-right" aria-hidden="true"></i> <Link to='/services/ecommerce-development-ahmedabad'>Ecommerce Development</Link></li>
                                                <li><i className="fas fa-chevron-right" aria-hidden="true"></i> <Link to='/services/cloud-server-solution'>Cloud server Solution</Link></li>
                                                <li><i className="fas fa-chevron-right" aria-hidden="true"></i> <Link to='/services/mobile-app-development'>Mobile App Development</Link></li>
                                                <li><i className="fas fa-chevron-right" aria-hidden="true"></i> <Link to='/services/erp-crm-solution'>ERP/CRM Solution</Link></li>
                                                <li><i className="fas fa-chevron-right" aria-hidden="true"></i> <Link to='/services/graphics-design'>Graphics Design</Link></li>
                                                <li><i className="fas fa-chevron-right" aria-hidden="true"></i> <Link to='/services/domain-hosting'>Domain & Hosting</Link></li>
                                            </ul>
                                        </div>
                                    </div>
                                    {/* Footer Column */}
                                    <div className="footer-column col-lg-6 col-md-6 col-sm-12">
                                        <div className="footer-widget instagram-widget">
                                            <h4>Official info:</h4>

                                            <ul className="contact-list">
                                                <li>
                                                    <span className="icon fas fa-map-marker-alt" />
                                                    4th Floor, Mahalay Complex, 403, Chimanlal Girdharlal Rd, Opp. President Hotel, Vasant Vihar, Navrangpura, Ahmedabad, Gujarat 380009
                                                </li>
                                                <li>
                                                    <span className="icon fa fa-phone" /> +91 98988 76310
                                                </li>
                                                <li>
                                                    <span className="icon fa fa-envelope" /> info@hwplindia.com
                                                </li>
                                                <li className="social-icons">
                                                    <a href="https://www.facebook.com/HorizonWebinfo/" target="_blank" rel="noopener noreferrer">
                                                        <i className="fab fa-facebook-f" />
                                                    </a>
                                                    <a href="https://x.com/hwplindia" target="_blank" rel="noopener noreferrer">
                                                        <i className="fab fa-twitter" />
                                                    </a>
                                                    <a href="https://www.instagram.com/hwplindia/" target="_blank" rel="noopener noreferrer">
                                                        <i className="fab fa-instagram" />
                                                    </a>
                                                    <a href="https://in.pinterest.com/hwplindia/" target="_blank" rel="noopener noreferrer">
                                                        <i className="fab fa-pinterest" />
                                                    </a>
                                                </li>
                                            </ul>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="footer-bottom">
                        <div className="footer-single-line">
                            <div className="left-text">
                                © 2025 Horizon Webinfo Pvt. Ltd.  All Rights Reserved.
                            </div>
                            <div className="right-links">
                                <Link to='/terms-and-conditions'> <span>Terms and Conditions</span> </Link> |
                                <Link to='/privacy-policy'> <span>Privacy Policy</span> </Link> |
                                <Link to='/refund'> <span>Refund</span> </Link>
                            </div>
                        </div>
                    </div>

                </div>
            </footer>
        </div>
    )
};
